export const defaultLanguage = 'en';

export const availableLanguages = [
  'en',
  'fr',
];
